<template>
  <!--568 404-->
  <div
    role="button"
    class="product-thumbnail-wrapper product-thumbnail-height"
    :class="[stockMessage ? 'productThumbnail-with-stockMessage-height' : '']"
    tabindex="0"
    @click="toggleProductSlideout"
    @keydown.enter="toggleProductSlideout"
    @keydown.space.prevent="toggleProductSlideout"
  >
    <ProductThumbnail
      :product="product"
      :image-badge="imageBadge"
      :image-width="imageWidth"
      :alignment="alignment"
      :enable-click-on-brand-and-product="enableClickOnBrandAndProduct"
      :image-size="imageSize"
      :show-wish-list-btn-on-image="showWishListBtnOnImage"
      :click-action="fireEvent ? 'fireEvent' : 'disabled'"
      :is-large-card="isLargeCard"
      :url-template="urlTemplate"
      :fetch-priority="imageFetchPriority"
      :lazy-load="!imageFetchPriority"
      @update-upc-id="handleUpdateUpcId"
      @update-selected-size="handleUpdateSelectedSize"
      @update-selected-color-id="handleUpdateSelectedColor"
    />
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue';
import { SET_UPC_DETAILS, SET_UPDATED_SIZE, SET_UPDATED_COLOR } from '~/types/mutations';
import { useEnvPropsStore } from '~/stores/envProps';
import { useQuickViewStore } from '~/stores/quickView';
import ProductThumbnail from '@nuxt-common/product-thumbnail/app/components/ProductThumbnail.vue';

const emit = defineEmits('toggleProductSlideout');

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  alignment: {
    type: String,
    required: false,
    default: 'vertical', // ['vertical', 'horizontal]
  },
  imageSize: {
    type: String,
    required: false,
    default: '',
  },
  enableClickOnBrandAndProduct: {
    type: Boolean,
    required: false,
    default: true,
  },
  showWishListBtnOnImage: {
    type: Boolean,
    required: false,
    default: false,
  },
  fireEvent: {
    type: Boolean,
    default: false,
    required: false,
  },
  isLargeCard: {
    type: Boolean,
    required: false,
    default: false,
  },
  imageBadge: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  disableColor: {
    type: Boolean,
    required: false,
    default: false,
  },
  stockMessage: {
    type: String,
    required: false,
    default: '',
  },
  imageWidth: {
    type: Number,
    required: false,
  },
  imageFetchPriority: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const envPropsStore = useEnvPropsStore();
const quickViewStore = useQuickViewStore();

const productURLTemplate = computed(() => envPropsStore.envProps?.productURLTemplate);
const urlTemplate = computed(() => ({
  swatch: `${productURLTemplate.value}swatches/`,
  swatchSprite: productURLTemplate.value,
  product: `${productURLTemplate.value}products/`,
}));

const toggleProductSlideout = (event) => {
  if (props.fireEvent) {
    event.preventDefault();
    emit('toggleProductSlideout', props.product);
  }
};

const handleUpdateUpcId = (upc) => {
  if (upc.upcId) quickViewStore[SET_UPC_DETAILS](upc);
};
const handleUpdateSelectedColor = (color) => {
  quickViewStore[SET_UPDATED_COLOR](color);
};
const handleUpdateSelectedSize = (size) => {
  quickViewStore[SET_UPDATED_SIZE](size);
};
</script>

<style lang="scss" scoped>
.product-thumbnail-height {
  height: rem-calc(568);
  @include breakpoint(small only) {
    height: rem-calc(384);
  }
  @include breakpoint(medium only) {
    height: rem-calc(450);
  }
  @media only screen and (device-width: 1024px) {
    height: rem-calc(412);
  }
  @media only screen and (device-width: 1440px) {
    height: rem-calc(520);
  }
}
.productThumbnail-with-stockMessage-height {
  @include breakpoint(medium down) {
    height: rem-calc(384);
  }
}
</style>
